import { ActionType, createAsyncAction } from "typesafe-actions";

import { SandboxConfig } from "@mapmycustomers/shared/types/Sandbox";

export const createSandboxConfig = createAsyncAction(
  "settings/sandbox/create/request",
  "settings/sandbox/create/success",
  "settings/sandbox/create/failure"
)<{ callback?: () => void; name: string }, void, unknown>();

export const updateSandboxConfig = createAsyncAction(
  "settings/sandbox/update/request",
  "settings/sandbox/update/success",
  "settings/sandbox/update/failure"
)<SandboxConfig, void, unknown>();

export const deleteSandboxConfig = createAsyncAction(
  "settings/sandbox/delete/request",
  "settings/sandbox/delete/success",
  "settings/sandbox/delete/failure"
)<void, void, unknown>();

export const initSandboxPage = createAsyncAction(
  "settings/sandbox/init/request",
  "settings/sandbox/init/success",
  "settings/sandbox/init/failure"
)<void, { hasIntegration: boolean }, unknown>();

export type Actions = ActionType<
  | typeof createSandboxConfig
  | typeof deleteSandboxConfig
  | typeof initSandboxPage
  | typeof updateSandboxConfig
>;
